<rcl-modal [show]="showModal" (onClose)="closeModal()" [mobileFullScreen]="false">
	<rcl-modal-content class="vaccination-reminder-container">
		<rcl-modal-title>
			<a (click)="closeModal()" class="vaccination-reminder-close-container">
				<img inline-svg title="Close" [src]="'assets/icons/close-' + brandName + '.svg'" [alt]="'close ' + brandName + ' icon'" />
			</a>
			<img inline-svg title="Warning" [src]="'assets/icons/vaccination-reminder-' + brandName + '.svg'" [alt]="'vaccination reminder ' + brandName + ' icon'"/>
			<div class="vaccination-reminder-header">{{ bundle && bundle['label.vaccination.reminder.takeover.headline'] }}</div>
			<div class="vaccination-reminder-subheader">
				{{ bundle && bundle['label.vaccination.reminder.takeover.subcopy'] }}
			</div>
		</rcl-modal-title>
		<div class="vaccination-reminder-body">
			<a
				class="app-banner-download app-banner-download-left"
				*ngIf="device === constants.DEVICE_TYPE.DESKTOP || isAppleDevice"
				title="app-store"
				[href]="device === constants.DEVICE_TYPE.DESKTOP ? mobileAppLinks.ios : mobileAppLinks.unified"
				(click)="trackDeepLink(constants.OS_TYPE.IOS)"
				target="_blank"
			>
				<img src="assets/images/download-appstore@2x.png" alt="App Store" />
			</a>
			<a
				class="app-banner-download app-banner-download-right"
				*ngIf="device === constants.DEVICE_TYPE.DESKTOP || isAndroidDevice"
				title="google-play"
				[href]="device === constants.DEVICE_TYPE.DESKTOP ? mobileAppLinks.android : mobileAppLinks.unified"
				(click)="trackDeepLink(constants.OS_TYPE.ANDROID)"
				target="_blank"
			>
				<img src="assets/images/download-googleplay@2x.png" alt="Google Play" />
			</a>
		</div>
	</rcl-modal-content>
</rcl-modal>
